import { render, staticRenderFns } from "./AddFile.vue?vue&type=template&id=2f09ee07&"
import script from "./AddFile.vue?vue&type=script&lang=ts&"
export * from "./AddFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports